<template>
  <BaseModal
    dataClass="confirm-modal"
    size="md"
    :title="columnInfos.confirm.label"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-slot:main>
      <b-alert show variant="info">
        {{ message }}
      </b-alert>
    </template>
    <template v-slot:footer="{ cancel }">
      <!-- はいボタン -->
      <BaseButton
        variant="primary"
        :columnInfo="columnInfos.yes"
        @click="confirm"
      />
      <!-- いいえボタン -->
      <BaseButton
        variant="primary"
        :columnInfo="columnInfos.no"
        @click="cancel"
      />
    </template>
  </BaseModal>
</template>

<script>
export default {
  name: 'ConfirmModal',

  inheritAttrs: false,

  props: {
    /**
     * 項目定義情報.
     * @type {Object}
     */
    columnInfos: {
      type: Object,
      required: true,
    },

    /**
     * メッセージ.
     * @type {String}
     */
    message: {
      type: String,
      default: '',
    },

    event: {
      type: String,
      default: 'confirm',
    },
  },

  methods: {
    /**
     * はい押下時の処理です.
     */
    confirm() {
      this.$emit(this.event)
    },
  },
}
</script>
